import cx from 'classnames'

export const borderStyles = cx('border-slate-200 dark:border-slate-700')
